import { CurrentUSer } from '../utils/CurrentUser';
import { UserSettings } from '../utils/UserSettings';
import { Message } from '../utils/Message';
import { GlobalEventEmitterService } from './global-event-emitter.service';
import { ChangeEvent } from '../events/ChangeEvent';
import { Subscription, timer, Subject } from 'rxjs';
import { ITimeAxis } from 'projects/game-utils/src/lib/utils/timer/factory/time/ITimeAxis';
import { AbstractTimeAxisService } from './AbstractTimeAxisService';

export abstract class AbstractGs {
    user:CurrentUSer;
    settings:UserSettings;
    points:number = 0;
    private gameRules:string;
    private diagramType:string;

    private createDate:Date = new Date();
    private gsCounter:number = 0;
    
    public abstract createNewGame(rules:string, type:string):void;

    public abstract getGameRulesString():string;

    public abstract getShortcut(rules:string):string;

    public beat(lives:number, position:number, value:number):void {
      this.user.beat(lives);
      if (position >= 0) {				
        var msg:Message = new Message();
        msg.name = "beatNumbersOnBoard";
        msg.params = new Array();
        msg.params[0] = "1";
        msg.params[1] = position + "";
        msg.params[2] = value + "";
        GlobalEventEmitterService.globalEmitter.emit(new ChangeEvent("changeEvent", msg));
      }
    }
    
    public stop(lives:number):void
    {
      if( this.timer != null ){
        this.timer.stop( lives );
      }
      }
  public startPanel(pointIntime:number, percentInTime:number):void
  {
    if (this.user.getLives() > 0)
    {
      this.stop(this.user.getLives());
      //this.refreshLives(); //to tylko ustawienie labelka
      this.timer.startPanel( pointIntime, percentInTime );
    }
  }

    public getPlayegGsId():string
    {
      return this.createDate.getTime().toString() + "_" + this.gsCounter++;
    }

    public connectWithVirtual(rules:string, type:string):boolean
    {
      this.setGameRules( rules );
      this.setDiagramType( type );
      
      this.createNewGame(rules, type);
      return true;
    }

    public getDiagramType():string{
      return this.diagramType;
    }
    public setDiagramType( diagramType:string ) : void{
      this.diagramType = diagramType;
    }

    public getGameRules():string{
      return this.gameRules;
    }
    public setGameRules( gameRules:string ) : void{
      this.gameRules = gameRules;
    }
    public coinsSubject:Subject<number> = new Subject<number>();
    
    public freezeTime( freeze:boolean, addTime:number = 30 * 1000 ) : void {
      this.timer.freezeTime( freeze, addTime );
    }

    subscribe:Subscription;

      //-------------- DynamicPanel content
      public timer:ITimeAxis;

      public getTimer():ITimeAxis{
        return this.timer;
      }
      public setVisible( visible:boolean, axisManager:AbstractTimeAxisService ):void {  
          this.timer = axisManager.createTimeAxis( this.getGameRules(), this.getDiagramType() );
      }

    public addPoints( points:number ):void{
      this.points += points;
    }

    updateSettings(rules:string, playerLocale:string, sendNotofocation:boolean, showInRankings:boolean):void
    {
      if (this.settings == null)
      {
        this.settings = new UserSettings(sendNotofocation, showInRankings, playerLocale, rules);
      }
      else
      {
        this.settings.playerLocale = playerLocale;
        this.settings.rules = rules;
        this.settings.sendNotification = sendNotofocation;
        this.settings.showInRankings = showInRankings;
      }
    }
    
    public prepareToHideWaitWindow(listener:Function):void {
      let source = timer(2500);
      let _this = this;
      if( listener != null){
        this.subscribe = source.subscribe(  (val) => listener());
      }else{
        this.subscribe = source.subscribe(  (val) => _this.hideWaitWindow());  
      }
    }
    public hideWaitWindow():boolean
    {
      let waitWindowMsg:Message = new Message();
      waitWindowMsg.name = "SHOW_HIDE_WINDOW";
      waitWindowMsg.params = new Array();
      waitWindowMsg.params[0] = "WaitWindow";
      waitWindowMsg.params[1] = "false";
      GlobalEventEmitterService.globalEmitter.emit(new ChangeEvent("changeEvent", waitWindowMsg));
      return false;
    }  
    
    public showWaitingPopup():void
    {
        let waitWindowMsg:Message = new Message();
        waitWindowMsg.name = "SHOW_HIDE_WINDOW";
        waitWindowMsg.params = new Array();
        waitWindowMsg.params[0] = "WaitWindow";
        waitWindowMsg.params[1] = "true";
        GlobalEventEmitterService.globalEmitter.emit(new ChangeEvent("changeEvent", waitWindowMsg));
    }

}